/**
 * Polyfills
 *
 * @package DGD Platinum
 * @since   1.0.0
 */

import 'core-js/modules/es.promise';
import 'core-js/modules/es.object.assign';
import 'intersection-observer';
import stickybits from 'stickybits';

/**
 * Sticky elements (IE support) with Stickybits.
 * Stickybits is a lightweight alternative to position: sticky polyfills.
 * It works perfectly for things like sticky headers.
 *
 * @reference: https://github.com/dollarshaveclub/stickybits
 */
stickybits('.sticky', { scrollEl: 'body' });

/**
 * Cross-browser requestAnimationFrame function.
 *
 * @since 1.0.1
//  */
window.requestAnimationFrame = window.requestAnimationFrame
|| window.mozRequestAnimationFrame
|| window.webkitRequestAnimationFrame
|| window.msRequestAnimationFrame
|| function (f) { setTimeout(f, 1000 / 60); };

/**
 * Element.closest() Polyfill
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
	Element.prototype.closest = function (s) {
		let el = this;
		do {
			if (el.matches(s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};
}
